import { useTranslation } from "react-i18next";
import POSCartPage from "../pos-cart/POSCart.page";
import "./POSCheckout.style.scss";

function POSCheckoutPage() {
  const [t] = useTranslation();

  return <POSCartPage isCheckout={true} title={t("posCheckout.title")} />;
}

export default POSCheckoutPage;
